import { NAME} from './constants';

export const allPicklists = state => state[NAME].picklists;
export const allUsers = state => state[NAME].users;
